import classNames from 'classnames';
import React from 'react';
import ActionButton from '@react/Eligibility/ActionButton';
import LinkButton from '@react/Eligibility/LinkButton';
import SearchForm from '@react/Eligibility/SearchForm';
import { useEligibilityContext } from '@react/Eligibility/useEligibilityState';
const EligibilityValid = () => {
    const [{ products, searchValue, selectedEmployer }, dispatch] = useEligibilityContext();
    return (React.createElement("div", { className: "ec-valid" },
        React.createElement("div", { className: "site-wide-new" },
            React.createElement("div", { className: "ec-valid__scroll-outer" },
                React.createElement("div", { className: "ec-valid__scroll-inner" },
                    React.createElement(SearchForm, { initialValue: searchValue }),
                    React.createElement("h3", { className: "ec-valid__subtitle" }, "Products available:"),
                    React.createElement("div", { className: "ec-valid__product-list" }, products.map(product => {
                        const isActive = selectedEmployer?.salaryFinanceEmployerDetails?.sfEmployerProducts?.some((p) => p.productCode === product?.productCode) ?? false;
                        const employerProduct = selectedEmployer?.salaryFinanceEmployerDetails?.sfEmployerProducts?.find((p) => p.productCode === product?.productCode);
                        const itemClassName = classNames({
                            'ec-valid__product': true,
                            [`ec-valid__product--${product.colour ?? 'ocean'}`]: true,
                            'ec-valid__product--inactive': !isActive,
                        });
                        return (React.createElement("div", { key: product.name, className: "ec-valid__product-list-item" },
                            React.createElement("div", { className: itemClassName },
                                React.createElement("header", { className: "ec-valid__product-header" },
                                    React.createElement("img", { className: "ec-valid__product-image", src: product.image, alt: "" })),
                                React.createElement("div", { className: "ec-valid__product-content" },
                                    React.createElement("h3", { className: "ec-valid__product-title" }, product.name),
                                    React.createElement("p", { className: "ec-valid__product-summary" }, product.subTitle),
                                    !isActive ? (React.createElement(ActionButton, { text: product.registerButtonText
                                            ? product.registerButtonText
                                            : 'Register Interest', clickAction: () => {
                                            dispatch({
                                                type: 'SET_SELECTED_EMPLOYEE',
                                                payload: {
                                                    searchValue: selectedEmployer?.employerName,
                                                    product: product,
                                                    productError: true,
                                                },
                                            });
                                        } })) : (React.createElement(LinkButton, { href: formatProductLink(selectedEmployer?.salaryFinanceEmployerDetails?.employerUrlName ?? '', employerProduct?.uriTemplate ?? ''), text: product.applyButtonText ? product.applyButtonText : 'Apply Now' })))),
                            !isActive && React.createElement("small", null, "Sorry, this product is not available yet")));
                    })))))));
};
export default EligibilityValid;
export function formatProductLink(employerUrlName, uriTemplate) {
    return uriTemplate.replaceAll('{employerurlname}', employerUrlName);
}
